import i18n from '@/libs/i18n'

export default [
  {
    get header() {
      return i18n.t('accounting.title')
    },
    permission: 'get-invoice',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('clinic.doctors')
    },
    route: 'doctor',
    icon: 'PlusCircleIcon',
    permission: 'get-invoice',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.doctor')
    },
    route: 'doctor-accounting',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.patient')
    },
    route: 'accounting-patient',
    permission: 'get-invoice',
    icon: 'HomeIcon',
    role: ['Accounting', 'Cashier', 'Cashiers', 'cashier'],
  },
  // {
  //   get title() {
  //     return i18n.t('common.patient-history')
  //   },
  //   route: 'accounting-patient-history',
  //   permission: 'get-invoice',
  //   icon: 'ListIcon',
  //   role: ['Accounting', 'Cashier', 'Cashiers', 'cashier'],
  // },

  // {
  //   get title() {
  //     return i18n.t("accounting.surgery-accounting");
  //   },
  //   route: "surgery-accounting",
  //   permission: "get-invoice",
  //   icon: "ListIcon",
  //   role: "Accounting",
  // },
  {
    get title() {
      return i18n.t('surgery.Specify-surgery-price')
    },
    route: 'specify-surgery-price',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  // {
  //   get title() {
  //     return i18n.t("accounting.setPriceSurgery");
  //   },
  //   route: "surgery-patient-history-accounting",
  //   permission: "get-invoice",
  //   icon: "ListIcon",
  //   role: "Accounting",
  // },
  {
    get title() {
      return i18n.t('quickInvoice.title')
    },
    route: 'quick-invoice-accounting',
    icon: 'BriefcaseIcon',
    permission: 'get-quickInvoice',
    role: 'Accounting',
  },
  /// //////////////////// doctor expenses ///////////////////////
  {
    get title() {
      return i18n.t('surgery.Doctors-Expenses')
    },
    route: 'doctor-expenses',
    icon: 'DollarSignIcon',
    permission: 'get-hospitalExpense',
    role: 'Accounting',
  },

  /// //////////////////// hospital expenses and income ///////////////////////
  {
    get title() {
      return i18n.t('hospital.hospital-expenses')
    },
    route: 'hospital-expenses',
    icon: 'DollarSignIcon',
    permission: 'get-hospitalExpense',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('hospital.hospital-income')
    },
    route: 'hospital-income',
    icon: 'DollarSignIcon',
    permission: 'get-hospitalIncome',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('hospital.hospital-exchange-rate')
    },
    route: 'hospital-exchange-rate',
    icon: 'ShieldIcon',
    permission: 'get-hospitalExchangeRate',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.accounting-balance')
    },
    route: 'accounting-balance',
    icon: 'DollarSignIcon',
    permission: 'get-balance',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('QuickInvoiceType.title')
    },
    route: 'quick-invoice-type',
    permission: 'get-quickInvoiceType',
    icon: 'BriefcaseIcon',
    role: 'Accounting',
  },
  // {
  //   get title() {
  //     return i18n.t("accounting.bed-rest-accounting");
  //   },
  //   route: "bed-rest-accounting",
  //   permission: "get-invoice",
  //   icon: "BriefcaseIcon",
  //   role: ["Accounting", "Cashier", "Cashiers", "cashier"],
  // },
  {
    get title() {
      return i18n.t('cashiers.title')
    },
    route: 'cashiers-pending',
    permission: 'get-cashiers-with-pending-invoices',
    icon: 'UsersIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.approved-invoices')
    },
    route: 'approved-invoices',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.reports-surgery-operations')
    },
    route: 'reports-surgery-operations',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.reports-rejected-invoices-history')
    },
    route: 'report-rejected-history',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.reports-laboratory')
    },
    route: 'laboratory-report',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.reports-doctors-revenue')
    },
    route: 'doctors-revenue-report',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.casher-report')
    },
    route: 'casher-report',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
  {
    get title() {
      return i18n.t('accounting.reports-revenue')
    },
    route: 'revenue-report',
    permission: 'get-invoice',
    icon: 'ListIcon',
    role: 'Accounting',
  },
]
